import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    EventEmitter,
    forwardRef,
    Input,
    Optional,
    Output,
    Renderer2,
    ViewChild,
    ViewEncapsulation,
} from '@angular/core';
import { FormGroupDirective, NG_VALUE_ACCESSOR, UntypedFormControl } from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import Debug from 'debug';
import { AumFormField } from './aum-form-field';

const debug = Debug('aumico:aumico-lib-core-fe:AumInput');

/**
 * to overwrite the with you have to change the css of .mat-form-field-infix
 */
@Component({
    selector: 'aum-input',
    styleUrls: ['./aum-form-field.scss', './aum-form-field-outline.scss', './aum-input.scss'],
    templateUrl: './aum-input.html',
    encapsulation: ViewEncapsulation.None,
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AumInput),
            multi: true,
        },
    ],

    host: {
        class: 'aum-input aum-form-field',
    },
    inputs: ['size'],
})
export class AumInput extends AumFormField implements AfterViewInit {
    @ViewChild('input', { static: true }) el: ElementRef<HTMLInputElement>;

    @Input() type: string = 'text';

    @Input() control: UntypedFormControl = new UntypedFormControl();

    @Input() useIndependentControl: false;

    @Input() errorStateMatcher: ErrorStateMatcher | undefined;
    shouldDisplayWarningTriangle = false;
    private readonly parentForm: FormGroupDirective | null;

    @Output() onInputFocus = new EventEmitter<void>();

    constructor(
        el: ElementRef,
        changeDetectorRef: ChangeDetectorRef,
        renderer: Renderer2,
        matIconRegistry: MatIconRegistry,
        domSanitizer: DomSanitizer,
        @Optional() private _parentFormGroup: FormGroupDirective,
    ) {
        super(el, changeDetectorRef, renderer, matIconRegistry, domSanitizer);
        this.parentForm = _parentFormGroup || null;
    }

    recalculateErrorState(): void {
        if (this.errorStateMatcher == null) {
            this.shouldDisplayWarningTriangle = this.aumFormControl.touched && this.aumFormControl.invalid;
        } else {
            this.shouldDisplayWarningTriangle = this.errorStateMatcher.isErrorState(
                this.aumFormControl,
                this.parentForm,
            );
        }
    }

    onFocus(): void {
        this.onInputFocus.emit();
    }

    ngAfterViewInit(): void {
        const randomString = Math.random().toString(36).slice(-6);
        this.renderer.setAttribute(this.el.nativeElement, 'name', randomString);
        this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', randomString);

        this.aumFormControl.valueChanges.subscribe(() => {
            this.recalculateErrorState();
        });
    }
}
